import { render, staticRenderFns } from "./submitTask.vue?vue&type=template&id=13a8440e&scoped=true&"
import script from "./submitTask.vue?vue&type=script&lang=js&"
export * from "./submitTask.vue?vue&type=script&lang=js&"
import style0 from "./submitTask.vue?vue&type=style&index=0&id=13a8440e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8440e",
  null
  
)

export default component.exports